/**
 * @file Header
 */

/**
 * Header component
 */
const vHeader = () => {
	const header = document.querySelector('.v-header');

	if (!header) {
		return;
	}

	let animationTimeout;
	const animationDelay =
		parseFloat(
			getComputedStyle(header).getPropertyValue(
				'--stuck-transition-duration',
			) || '0.5s',
		) * 1000;

	const stickyObserver = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (animationTimeout) {
					clearTimeout(animationTimeout);
				}

				header.classList.toggle('is-stuck', entry.intersectionRatio < 1);
				if (entry.intersectionRatio < 1) {
					header.classList.add('is-animated');
				} else {
					animationTimeout = setTimeout(() => {
						header.classList.remove('is-animated');
					}, animationDelay);
				}
			});
		},
		{ threshold: [1] },
	);

	stickyObserver.observe(header);
};

export default vHeader;
